export { default as PersonalInfo } from './PersonalInfo';
export { default as EditPersonalInfo } from './EditInfo';
export { default as ChangePassword } from './ChangePassword';
export { default as NewClientCode } from './NewClientCode';
